module.exports = __webpack_public_path__ + "img/qygl2.56dca5dc.jpg";